export default __webpack_public_path__ + "static/media/File No. 28.fb15016f.pdf";